import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/**
 * Check if any special character is present in input
 *
 * @param {string} allowedCharacters
 * @returns {ValidatorFn}
 */
export function validateAllowedCharacters(allowedCharacters: string): ValidatorFn {

    //Allowing Alphabets, Space, - and .
    let regexString = '^[a-zA-Z\\s-.';

    if (allowedCharacters.length > 0) {

        regexString = regexString + allowedCharacters;
    }

    // Create Regex Pattern
    let regexPattern = new RegExp(regexString + ']*$');

    return (control: AbstractControl): { [key: string]: any } => {

        if (!control.value) {

            return null;
        }

        if (regexPattern.test(control.value)) {

            return null;
        }

        return {'validateAllowedCharacters': {value: control.value}};
    };
}


@Directive({
    selector: '[validateAllowedCharacters]',
    providers: [{provide: NG_VALIDATORS, useExisting: AllowedCharactersValidatorDirective, multi: true}]
})
export class AllowedCharactersValidatorDirective implements Validator {
    @Input() allowedCharacters: string;

    validate(control: AbstractControl): { [key: string]: any } {

        return validateAllowedCharacters(this.allowedCharacters)(control);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/validators/allowed-characters-validator.directive.ts